module.exports = __webpack_public_path__ + "img/benefit_dodgers-all-access.e3f51421.jpg";